<!-- Footer Area-->
<footer class="footer-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-sm-6">
                <div class="footer-widget">
                    <div class="logo_brand" style="padding-top: 18px;margin-bottom: 25px;">Dr. Asfar Ahamed</div>
                     
                    <p>Expert General, Laparoscopic Surgeon and Laser Surgeon | Specializing in Advanced Minimal Access and Gastrointestinal Surgeries.</p>
                    <!-- <ul class="footer-socials">
                        <li><a href="https://www.facebook.com/vconfiger.analytics.9" target="_blank"><i
                                    class='bx bxl-facebook'></i></a></li>
                        <li><a href="https://x.com/VconfigerA" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="https://www.linkedin.com/in/vconfiger-analytics-1a1b60245/" target="_blank"><i
                                    class='bx bxl-linkedin'></i></a></li>
                        <li><a href="https://www.youtube.com/channel/UCvUfDT3NnezvSO7DH4rM2tQ" target="_blank"><i
                                    class='bx bxl-youtube'></i></a></li>
                        <li><a href="https://www.youtube.com/channel/UC6o2NNmzQSg_OL_kwzExwRA" target="_blank"><i
                                    class='bx bxl-youtube'></i></a></li>
                                    <li><a href="https://www.instagram.com/configertechnologies7/" target="_blank"><i
                                        class='bx bxl-instagram'></i></a></li>

                    </ul> -->
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="footer-widget pl-80">
                    <h3>Company</h3>
                    <ul class="footer-text">
                        <li><a routerLink="/about"><i class="bx bxs-chevrons-right"></i>About Me</a></li>
                        <li><a routerLink="/blog"><i class="bx bxs-chevrons-right"></i>Health Blog</a></li>
                        <li><a routerLink="/services"><i class="bx bxs-chevrons-right"></i>Treatments</a></li>
                        <!-- <li><a routerLink="/events"><i class="bx bxs-chevrons-right"></i>Events</a></li> -->

                        <li><a routerLink="/contact"><i class="bx bxs-chevrons-right"></i>Contact us</a></li>

                        <!-- <li><a routerLink="/">Cost calculator</a></li>
                        <li><a routerLink="/">Latest News</a></li> -->
                    </ul>
                </div>
            </div>
        
       

            <div class="col-lg-4 col-sm-6">
                <div class="footer-widget">
                    <h3>Our Treatments</h3>
                    <ul class="footer-text">
                        <li *ngFor="let services of courses"><a routerLink="/treatments/{{services.servicesUrl}}"><i class="bx bxs-chevrons-right"></i>{{services.navbartext}}</a></li>
                        <!-- <li><a routerLink="/blog"><i class="bx bxs-chevrons-right"></i>Treatments</a></li> -->
                        <!-- <li><a routerLink="/events"><i class="bx bxs-chevrons-right"></i>Events</a></li> -->
                       
                        <!-- <li><i class='bx bxs-phone'></i> <a>+1 (732) 692- 4748 </a></li>
                        <li><i class='bx bxs-phone'></i> <a>+1 (848) 248- 2421 </a></li>

                        <li><i class='bx bxs-envelope'></i><a
                                href="mailto:info.us@vconfiger.com">info.us@vconfiger.com</a></li> -->

                        <!-- <li><i class='bx bxs-phone'></i> <a href="tel:+14043847765">+1 (404) 384-7765</a></li> -->
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>
<!-- End Footer Area -->

<!-- Footer bottom Area -->
<div class="footer-bottom">
    <div class="container">
        <p>Copyright @2024 Dr. Asfar Ahamed & All Rights Reserved</p>
    </div>
</div>
<!-- End Footer bottom Area -->

<!-- Go Top -->
<div class="go-top">
    <i class='bx bx-chevrons-up'></i>
</div>
<!-- End Go Top -->